// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1448":"a80f01114725e606","1522":"c4105bc4d94b9f53","1844":"1972865dc235bcea","4549":"7b1eac918c69f4c3","5130":"1a4630f7229c5f42","5547":"30f9bfc91556edf1","6595":"2881b87c45a844b2","6969":"3f1c365af8a1fbc1","7882":"37c6122f0f9bee77","9714":"c90df78522dba9a9"}[chunkId] + ".js";
};